import { JSX, Show } from 'solid-js';
import { CustomTooltip, Icon } from '@tcweb/connect-ui';

/* TODO Guillaume remove when this is sorted out with UX:
  with classic light theme, buttons have press feedback but no
  hovering. with connect light theme, they have no press feedback but
  react to hovering */

export interface UvIconProps {
  dataTestId: string;
  type: 'action' | 'toggle';
  variant?: 'filled' | 'borderless' | 'outlined';
  pressed?: boolean;
  tooltip: string;
  icon: string;
  iconVariant?: 'outlined' | 'solid';
  onClick(): void;
  disabled: boolean;
  /** Whether to show an arrow on the tooltip. @default true */
  tooltipArrow?: boolean;
  /** Use Connect CSS button styling instead of Modus WC button. @default false */
  connectStyle?: boolean;
}

export const UvIconButton = (props: UvIconProps): JSX.Element => {
  return (
    <div data-testid={props.connectStyle ? undefined : props.dataTestId}>
      <CustomTooltip
        text={props.tooltip}
        position={'bottom' as any}
        arrow={props.tooltipArrow ?? true}
      >
        <Show
          when={!props.connectStyle}
          fallback={
            <button
              class="button tertiary icon-medium icon-circle"
              type="button"
              onClick={() => props.onClick()}
              data-cy={props.dataTestId}
              data-testid={props.dataTestId}
              disabled={props.disabled}
            >
              <Icon icon={props.icon} size="icon-medium" />
            </button>
          }
        >
          <modus-wc-button
            variant={
              props.pressed
                ? props.variant === 'outlined'
                  ? 'filled'
                  : props.type === 'toggle'
                    ? 'filled'
                    : 'outlined'
                : props.variant || 'borderless'
            }
            color="tertiary"
            on:buttonClick={() => props.onClick()}
            disabled={props.disabled}
            size="sm"
            shape="square"
          >
            <modus-wc-icon
              custom-class={
                props.icon.startsWith('tc-icon')
                  ? `icon-font ${props.icon} i24`
                  : undefined
              }
              name={props.icon.startsWith('tc-icon') ? undefined : props.icon}
              variant={props.iconVariant || 'outlined'}
            />
          </modus-wc-button>
        </Show>
      </CustomTooltip>
    </div>
  );
};
